import type {SlamPointCloudRepository} from '@/domain/interfaces/SlamPointCloudRepository';
import type {UavPointCloudRepository} from '@/domain/interfaces/UavPointCloudRepository';

export class ReUploadPointCloudsUseCase {
  constructor(private readonly repository: UavPointCloudRepository | SlamPointCloudRepository) {}
  async execute(uuid: string, file: File) {
    const urls = await this.repository.getUrls(uuid);
    return this.repository.upload(urls.uploadUrl, file);
  }
}
